/**
 * Per-tab marker that the user is in a multi-role onboarding flow (started with 2+ pending roles).
 * Used to preserve the OnboardingShell after one role is completed and only one pending remains,
 * so multi-role invitees keep their progress sidebar throughout the flow.
 *
 * Set when the overview renders with 2+ pending roles; cleared when 0 pending remain.
 */
export const MULTI_ROLE_ONBOARDING_FLOW_KEY = "multiRoleOnboardingFlow";

export const markMultiRoleOnboardingFlow = (): void => {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(MULTI_ROLE_ONBOARDING_FLOW_KEY, "1");
};

export const clearMultiRoleOnboardingFlow = (): void => {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(MULTI_ROLE_ONBOARDING_FLOW_KEY);
};

export const isMultiRoleOnboardingFlowActive = (): boolean => {
  if (typeof sessionStorage === "undefined") return false;
  return sessionStorage.getItem(MULTI_ROLE_ONBOARDING_FLOW_KEY) === "1";
};
